import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import sharp from '../images/card/Sharp-Industrial.gif'
import leptop from '../images/card/laptop-db.gif'
import rocky from '../images/card/rocky-fitness.gif'
import pure from '../images/card/pure-pd.gif'
import green from '../images/card/green-convention.gif'
import flim from '../images/card/Filmmaking-gadgets-1.gif'
import DomHeader from './DomHeader';

const ProjectDetails = () => {
    const myProjects = [
        {
            img: sharp,
            name: "Sharp-Industrial",
            title: "(Manufacturer Industry website)",
            link: "https://sharp-industrial.web.app/",
            description: "This is a Tools Manufecturer Industries Web site. user can order product from the Industries. users can calcel there order. We have a MasterPis DashBoard here admin can do all intaraction for web-site. we use stripe as payment method.",
            technologys: "React, Tailwind, NodeJS, ExpressJS, MongoDB, Firebase.",
            client: "https://github.com/najmul009/sharp-industries-client",
            server: "https://github.com/najmul009/sharp-industries-server"
        },
        {
            img: leptop,
            name: "Laptop-DB",
            title: "(Warehouse Management Website)",
            link: "https://leptop-db.firebaseapp.com/",
            description: "This is a WareHouse Management Website. Only admin can able to add or delete items. Admin able to update products and manage orders.Special route for every admin to watch activities.",
            technologys: "React, Bootstrap, NodeJS, ExpressJS, MongoDB, Firebase.",
            client: " https://github.com/najmul009/leptop-db-client",
            server: "https://github.com/najmul009/leptop-db-server"
        },
        {
            img: rocky,
            name: "Rocky-Fitness",
            title: "(Personal fitness Trainer webapp. )",
            link: "https://rocky-fitness-44935.web.app/",
            description: "ROCKY-FITNESS is a Personal fitness Trainer webapp. This project is a Single page application. Where user can login and signup, also able to reset password. We have service section for lists of services those are a personal trainer provide. We have review section for new user, so that they can get feedback from available user. Also user can Checkout services.",
            technologys: "React.js, CSS, Bootstrap, React Routers, Firebase, React-firebase-hoooks.",
            client: "https://github.com/najmul009/rocky-fitness",
            server: ""
        },
        {
            img: pure,
            name: "PurePD",
            title: "(Product analysis Website)",
            link: "https://purepd.netlify.app/",
            description: "PureED is a Product analysis Website. Where we can see how users feedback the product. So that we can get idea for product those are going to buy in future. Also we have rechart for showing our analytical data for Investment vs Revenue and Month wish sell. And this is a single page application. ",
            technologys: "React.js, CSS, Bootstrap, rechart, react-router-dom, react-rating, fortawesome",
            client: "https://github.com/najmul009/pure-pd",
            server: ""
        },
        {
            img: green,
            name: " Green-Convention-Center",
            title: "(Convention Center booking website)",
            link: "https://green-convention-center.netlify.app/",
            description: "Green Convention Center is a Convention Center booking website. Where user can get all of information and view about the Convention Center. It's Fully mobile responsive.",
            technologys: " HTML, CSS, Bootstrap",
            client: "https://github.com/najmul009/green-convention-center",
            server: ""
        },
        {
            img: flim,
            name: "Filmaking-Gadgets",
            title: "(Gadgets Online Shop)",
            link: "https://najmul009.github.io/Filmmaking-Gadgets/",
            description: "This is a Filmmaking-Gadgets Online Shop .",
            technologys: "HTML and CSS.",
            client: "https://github.com/najmul009/Filmmaking-Gadgets",
            server: ""
        }
    ]
    const { id } = useParams();

    const myProject = myProjects.find(project => project.name === id)
    console.log(myProject);
    return (
        <div>
            <DomHeader></DomHeader>
            <div className='lg:px-20 pb-10'>
                <div>
                <h1 className='text-center my-5 text-4xl font-bold text-white'>{myProject?.name}</h1>
                <p className='text-center my-5 text-xl font-bold text-white'>{myProject?.title}</p>
                </div>
                <div className='flex justify-center'>
                <img src={myProject?.img} alt="" />
                </div>

               
                <p className='text-center my-10 text-xl  text-white lg:px-20'>{myProject?.description}</p>
                <p className='text-center my-10 text-xl font-bold text-white'>Technologys:{myProject?.technologys}</p>

                <div className='flex justify-center gap-10'>

              

                <button className='btn btn-primary'>

                <a href={myProject?.link} target="blank" rel="noopener noreferrer">Live</a>
                </button>


                <button className='btn btn-primary'>

                <a href={myProject?.client} target="blank" rel="noopener noreferrer">Client Git</a>
                </button>
            
                <button className='btn btn-primary'>

                <a href={myProject?.server} target="blank" rel="noopener noreferrer">Server Git</a>
                </button>
                </div>

            </div>
        </div>
    );
}
export default ProjectDetails